export const BABYLIST_HEALTH_ICON =
  '//images.babylist.com/image/upload/v1676582868/DME/babylist-health-badge.svg'
export const ADD_CART_TEXT = 'No, Add to Cart'
export const ADD_TO_REGISTRY_TEXT = 'No, Add to Registry'
export const ORDER_THROUGH_INSURANCE_TEXT = 'Yes, Order through Insurance'
export const SEE_PRICES_TEXT = 'Yes, See Prices at Babylist Health'
const rootText =
  'Your health insurance may cover up to 100% of the cost of a breast pump.'
export const ADD_TO_CART_BODY_TEXT = rootText.concat(
  ' ',
  'Would you like to order your breast pump through insurance at Babylist Health?'
)
export const ADD_TO_REGISTRY_BODY_TEXT = rootText.concat(
  ' ',
  'Would you like to see prices for your insurance at Babylist Health?'
)
